// Site URL used for canonical tags and share links.
// Falls back to current origin if the env var is not set — safe in any environment.
export const SITE_URL =
  process.env.REACT_APP_SITE_URL ||
  (typeof window !== "undefined" ? window.location.origin : "");
